import React from 'react';
import TswDialog from 'components/v2/FormElements/Dialog'; // TODO: Come up with something here.  Form elements/modals are merged together here and it creates a dom validation error due to nestted forms.
import Form from './Form';

export const Dialog = ({ onClose, open, title, ...rest }) => {
  return (
    <TswDialog onClose={onClose} open={open} title={title}>
      <Form afterCancel={onClose} {...rest} isDialog={true} />
    </TswDialog>
  );
};

export default Dialog;
